import React from 'react';
import { useNavigate } from "react-router-dom";

import "Components/Footer/Footer.scss";
import {FaInstagram, FaFacebook, FaTwitter, FaPinterest} from 'react-icons/fa';

function Footer() {

    const CONF = window?.confPub;
    const ROUTES_PAGES = CONF?.ROUTES?.PAGES;
    const ROUTE_LABEL = CONF?.LINK_LABEL?.ROUTES;

    const navigate = useNavigate();

    return (
        <footer className="footer col-12">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="row">
                            <img
                                alt=""
                                src="../logo-blanc.svg"
                                width="70"
                                height="70"
                                className="d-inline-block align-top"
                            />
                        </div>

                    </div>

                    <div className="col-lg-4">

                        <ul>
                            <li>
                                <a className="liens bold-lien" onClick={ () => navigate(ROUTES_PAGES?.ROOT) }>
                                    { ROUTE_LABEL?.ACCUEIL }
                                </a>
                            </li>
                            <li>
                                <a className="liens bold-lien"
                                   onClick={ () => navigate(ROUTES_PAGES?.RECHERCHE_PERSONNE) }>
                                    { ROUTE_LABEL?.RECHERCHE_PERSONNE }
                                </a>
                            </li>
                            <li>
                                <a className="liens bold-lien"
                                   onClick={ () => navigate(ROUTES_PAGES?.INFOS_GENERALES) }>
                                    { ROUTE_LABEL?.INFOS_GENERALES }
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-lg-4">
                        <ul>
                            <li>
                                <a className="liens bold-lien"
                                   onClick={ () => navigate(ROUTES_PAGES?.ANNUAIRE_CORRESPONDANTS) }>
                                    { ROUTE_LABEL?.ANNUAIRE_CORRESPONDANTS }
                                </a>
                            </li>
                            <li>
                                <a className="liens bold-lien"
                                   onClick={ () => navigate(ROUTES_PAGES?.PROFIL?.MAIN) }>
                                    { ROUTE_LABEL?.PROFIL }
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>

                <div className='mt-3 d-flex justify-content-center'>
                    <ul>
                        <li className='inline'>
                            <a href="#" className="liens"
                               onClick={ () => navigate(ROUTES_PAGES?.ACCESSIBILITE) }>
                                { ROUTE_LABEL?.ACCESSIBILITE }
                            </a>
                        </li>
                        <li className='inline border-left'>
                            <a href="#" className="liens"
                               onClick={ () => navigate(ROUTES_PAGES?.PLAN_SITE) }>
                                { ROUTE_LABEL?.PLAN_SITE }
                            </a>
                        </li>
                        {/*<li className='inline border-left'>*/}
                        {/*    <a href="#" className="liens">Mention légales & CGU</a>*/}
                        {/*</li>*/}
                        {/*<li className='inline border-left'>*/}
                        {/*    <a href="#" className="liens">Données personnelles & cookie</a>*/}
                        {/*</li>*/}
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer;